import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'izy-select-pdf-style-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './select-pdf-style-dialog.component.html',
  styleUrl: './select-pdf-style-dialog.component.scss',
})
export class SelectPdfStyleDialogComponent {
  selectedStyle: string = 'style1'; // Default value

  constructor(
    public dialogRef: MatDialogRef<SelectPdfStyleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    },
  ) {
    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e le sue fasce non sono
       raggiungibili da uno stile incapsulato: servono le regole globali di
       .izy-info-dialog-panel, la veste dei dialog che informano o raccolgono
       un dato senza distruggere niente. La classe la aggiunge il componente e
       non i chiamanti perche' i punti di apertura sono quattro e la veste e'
       la stessa per tutti. */
    this.dialogRef.addPanelClass('izy-info-dialog-panel');

    /* Due dei quattro chiamanti passano ancora un'altezza fissa ('465px'),
       tarata sul vecchio contenuto centrato con l'icona da 80px. Ora che il
       contenuto e' piu' compatto, quell'altezza lascerebbe una striscia
       bianca vuota fra il selettore dello stile e la fascia panna: questa
       classe fa crescere il dialog quanto serve e non di piu'. */
    this.dialogRef.addPanelClass('izy-auto-height-dialog-panel');
  }

  downloadPdf(): void {
    this.dialogRef.close({
      download: true,
      style: this.selectedStyle,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}

@Component({
  selector: 'izy-select-preview-pdf-style-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './select-preview-pdf-style-dialog.component.html',
  styleUrl: './select-pdf-style-dialog.component.scss',
})
export class SelectPreviewPdfStyleDialogComponent {
  selectedStyle: string = 'style1'; // Default value

  constructor(
    public dialogRef: MatDialogRef<SelectPreviewPdfStyleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    },
  ) {
    /* Come nel gemello qui sopra: la veste della superficie e' globale perche'
       il dialog vive nell'overlay CDK, e l'altezza la detta il contenuto e non
       il '465px' che il chiamante passa ancora. */
    this.dialogRef.addPanelClass('izy-info-dialog-panel');
    this.dialogRef.addPanelClass('izy-auto-height-dialog-panel');
  }

  downloadPdf(): void {
    this.dialogRef.close({
      download: true,
      style: this.selectedStyle,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}
